import React from 'react'

const FutureVision = () => {
  return (
    <div>Future Vision</div>
  )
}

export default FutureVision